import { ETabs } from '../../../types/redux/tabs';

import { plural, TDevice } from '@cian/utils';

const prefix: [string, string, string] = ['Найден', 'Найдено', 'Найдено'];
const suffix: { [key: string]: [string, string, string] } = {
  [ETabs.Realtors]: ['риелтор', 'риелтора', 'риелторов'],
  [ETabs.Agencies]: ['агентство', 'агентства', 'агентств'],
};

export function getText(tab: ETabs, counts: number, deviceType: TDevice) {
  const correctSuffix = suffix[tab];

  if (deviceType === 'desktop') {
    const correctPrefix = tab === ETabs.Agencies ? 'Найдено' : plural(counts, prefix);

    return `${correctPrefix} ${counts} ${plural(counts, correctSuffix)}`;
  }

  return `${counts} ${plural(counts, correctSuffix)}`;
}
